import React, { useState } from "react";
import { connect } from "react-redux";
import ContentContainer from "../common/ContentContainer";
import { t } from "i18next";
import MarketIntelligenceContent from "./MarketIntelligenceContent";
import './MarketIntelligence.scss';

const MarketIntelligenceLanding = (props) => {
    const [isOpen, setIsOpen] = useState(true);

    const openModal = () => {
        setIsOpen(true);
    }
    const closeModal = () => {
        setIsOpen(false);
    }   

  return (
    <ContentContainer url="market-intelligence" title={t("marketIntelligence")} showChat={true}>
        <MarketIntelligenceContent isOpen={isOpen} close={closeModal} />
    </ContentContainer>
  );
};

export default connect(null, {})(MarketIntelligenceLanding);